// Event Action Types
export const FETCH_EVENTS_REQUEST = 'event/FETCH_EVENTS_REQUEST';
export const FETCH_EVENTS_SUCCESS = 'event/FETCH_EVENTS_SUCCESS';
export const FETCH_EVENTS_FAILURE = 'event/FETCH_EVENTS_FAILURE';

export const CREATE_EVENT_REQUEST = 'event/CREATE_EVENT_REQUEST';
export const CREATE_EVENT_SUCCESS = 'event/CREATE_EVENT_SUCCESS';
export const CREATE_EVENT_FAILURE = 'event/CREATE_EVENT_FAILURE';

export const UPDATE_EVENT_REQUEST = 'event/UPDATE_EVENT_REQUEST';
export const UPDATE_EVENT_SUCCESS = 'event/UPDATE_EVENT_SUCCESS';
export const UPDATE_EVENT_FAILURE = 'event/UPDATE_EVENT_FAILURE';

export const DELETE_EVENT_REQUEST = 'event/DELETE_EVENT_REQUEST';
export const DELETE_EVENT_SUCCESS = 'event/DELETE_EVENT_SUCCESS';
export const DELETE_EVENT_FAILURE = 'event/DELETE_EVENT_FAILURE';

export const FETCH_EVENT_DETAILS_REQUEST = 'event/FETCH_EVENT_DETAILS_REQUEST';
export const FETCH_EVENT_DETAILS_SUCCESS = 'event/FETCH_EVENT_DETAILS_SUCCESS';
export const FETCH_EVENT_DETAILS_FAILURE = 'event/FETCH_EVENT_DETAILS_FAILURE';

export const FETCH_EVENT_TICKETS_REQUEST = 'event/FETCH_EVENT_TICKETS_REQUEST';
export const FETCH_EVENT_TICKETS_SUCCESS = 'event/FETCH_EVENT_TICKETS_SUCCESS';
export const FETCH_EVENT_TICKETS_FAILURE = 'event/FETCH_EVENT_TICKETS_FAILURE';

export const FETCH_EVENT_TICKETS_EXCEL_REQUEST = 'event/FETCH_EVENT_TICKETS_EXCEL_REQUEST';
export const FETCH_EVENT_TICKETS_EXCEL_SUCCESS = 'event/FETCH_EVENT_TICKETS_EXCEL_SUCCESS';
export const FETCH_EVENT_TICKETS_EXCEL_FAILURE = 'event/FETCH_EVENT_TICKETS_EXCEL_FAILURE';
export const FETCH_EVENT_TICKETS_EXCEL_RESET = 'event/FETCH_EVENT_TICKETS_EXCEL_RESET';

export const CREATE_EVENT_BOOKING_ORDER_REQUEST = 'event/CREATE_EVENT_BOOKING_ORDER_REQUEST';
export const CREATE_EVENT_BOOKING_ORDER_SUCCESS = 'event/CREATE_EVENT_BOOKING_ORDER_SUCCESS';
export const CREATE_EVENT_BOOKING_ORDER_FAILURE = 'event/CREATE_EVENT_BOOKING_ORDER_FAILURE';
export const CREATE_EVENT_BOOKING_ORDER_RESET = 'event/CREATE_EVENT_BOOKING_ORDER_RESET';

export const VERIFY_EVENT_PAYMENT_REQUEST = 'event/VERIFY_EVENT_PAYMENT_REQUEST';
export const VERIFY_EVENT_PAYMENT_SUCCESS = 'event/VERIFY_EVENT_PAYMENT_SUCCESS';
export const VERIFY_EVENT_PAYMENT_FAILURE = 'event/VERIFY_EVENT_PAYMENT_FAILURE';
export const VERIFY_EVENT_PAYMENT_RESET = 'event/VERIFY_EVENT_PAYMENT_RESET';

export const RESET_EVENTS_STATE = 'event/RESET_EVENTS_STATE';
